var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilePhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#1DB960"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9093 29.3673V32.64C34.9105 32.9438 34.8483 33.2446 34.7265 33.5229C34.6048 33.8013 34.4263 34.0512 34.2024 34.2566C33.9786 34.462 33.7143 34.6184 33.4264 34.7157C33.1386 34.813 32.8337 34.8492 32.5311 34.8218C29.1742 34.4571 25.9496 33.31 23.1165 31.4727C20.4807 29.7978 18.246 27.5631 16.5711 24.9273C14.7274 22.0813 13.5801 18.8411 13.222 15.4691C13.1947 15.1674 13.2306 14.8634 13.3273 14.5763C13.4239 14.2893 13.5793 14.0255 13.7836 13.8018C13.9878 13.5781 14.2363 13.3993 14.5134 13.277C14.7905 13.1546 15.09 13.0912 15.3929 13.0909H18.6656C19.1951 13.0857 19.7083 13.2732 20.1097 13.6184C20.5112 13.9636 20.7733 14.443 20.8474 14.9673C20.9856 16.0146 21.2418 17.043 21.6111 18.0327C21.7579 18.4232 21.7896 18.8476 21.7026 19.2555C21.6156 19.6635 21.4135 20.038 21.1202 20.3346L19.7347 21.72C21.2877 24.4512 23.549 26.7125 26.2802 28.2655L27.6656 26.88C27.9622 26.5867 28.3367 26.3846 28.7447 26.2976C29.1526 26.2106 29.577 26.2423 29.9674 26.3891C30.9572 26.7584 31.9856 27.0146 33.0329 27.1527C33.5628 27.2275 34.0468 27.4944 34.3928 27.9027C34.7387 28.3111 34.9225 28.8323 34.9093 29.3673Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePhone);
export default __webpack_public_path__ + "static/media/MobilePhone.2f120509429d9a9bb459a22316ba467e.svg";
export { ForwardRef as ReactComponent };